export const LISTING_STORAGE_KEY = 'listingNavigationTempData';
export const TOKEN_HEADER_KEY = 'Authorization';
export const RESTRICTIVE_UI_LISTINGS = 'restrictiveUiListings';
export const VISUALS_ASSETS_VIEW_MODE = 'visuals.assets.viewMode';
export const VISUALS_CUSTOM_ASSETS_VIEW_MODE = 'visuals.customAssets.viewMode';
export const LISTINGS_TABLE_VIEW_MODE = 'listingsTable.viewMode';
